import {
  Box,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography
} from "@material-ui/core";
import React from "react";
import { API_URL } from "../../../../constants/api";
import { apiBatchRequest } from "../../../../utils/api_service";
import RenderChart from "../../../common/Chart/RenderChart";
import { getChartData } from "../../../../utils/graph_service";
import "./PointCompare.less";
import { ShowToast, toastType } from "../../../../utils/toast-service";
import moment from "moment";
import { removeDuplicates } from "../../../../utils/helper";
import { checkNegative } from "../../../../utils/generic";
const configDataMtd = {
  trend: {
    type: "MTD",
    key: "dataCenter"
  },
  columns: [
    {
      key: "",
      name: "Budgeted",
      type: "Amount ($)",
      filters: [],
      color: "#E59400",
      sortOrder: 0
    },
    {
      key: "",
      name: "Actual",
      type: "Amount ($)",
      filters: [],
      color: "#007300",
      sortOrder: 1
    }
  ]
};

const configDataYtd = {
  trend: {
    type: "Ytd",
    key: "dataCenter"
  },
  columns: [
    {
      key: "",
      name: "Budgeted",
      type: "Amount ($)",
      filters: [],
      color: "#E59400",
      sortOrder: 0
    },
    {
      key: "",
      name: "Actual",
      type: "Amount ($)",
      filters: [],
      color: "#007300",
      sortOrder: 1
    }
  ]
};
let resDataGraphMtd = undefined;
let resDataGraphYtd = undefined;
class PointCompare extends React.Component {
  constructor() {
    super();

    this.state = {
      SelectedDC: [],
      PropertyDetail: [],
      datacenterList: undefined,
      selectedKeyPoint: "",
      ytdGraphData: [],
      mtdGraphData: [],
      radioValue: "mtd",
      dataValuesBA: [{ Actual: "", Budgeted: "" }],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.setListData("firstCall");
  }

  componentWillReceiveProps(newProps) {
    if (
      this.props.datacenterList !== newProps.datacenterList ||
      this.props.PropertyDetail !== newProps.PropertyDetail ||
      this.props.DataHallCapacityList !== newProps.DataHallCapacityList ||
      this.props.startDate !== newProps.startDate
    ) {
      this.setState({
        datacenterList: newProps.datacenterList,
      });
      this.setListData("refreshCall");
    }
  }
  
  /** Set list data */
  setListData = call => {
    if (call == "firstCall") {
      this.setState(
        {
          datacenterList: this.props.datacenterList,
          selectedKeyPoint: this.props.compareForDcKey,
          SelectedDC: this.props.compareForDcName
            ? [this.props.compareForDcName]
            : []
        },
        () => {
          this._groupBy(this.props.PropertyDetail[0]);
          this.initDataAndChart(this.state.radioValue);
        }
      );
    } else {
      this.setState(
        {
          datacenterList: this.props.datacenterList,
          selectedKeyPoint: this.props.compareForDcKey
        },
        () => {
          this._groupBy(this.props.PropertyDetail[0]);
          this.initDataAndChart(this.state.radioValue);
        }
      );
    }
  };

  /** Handle change */
  handleChange = (e, type) => {
    if (this.state.selectedKeyPoint == "") {
      ShowToast("Please Select Point Value First", toastType.ERROR, 5000);
      return false;
    }
    let {SelectedDC} = this.state;
    if (type == "value") {

      if (SelectedDC.indexOf(e[e.length - 1]) !== -1) {
        SelectedDC = [];
        SelectedDC = e;
      } else {
        if (e[e.length - 1] != undefined) {
          SelectedDC.push(e[e.length - 1]);
        } else {
          SelectedDC = [];
        }
      }
    } else {
      const filteredAry = SelectedDC.filter(function(w) {
        return w !== e;
      });
      SelectedDC = filteredAry;
    }

    if (SelectedDC.length == 0) {
      ShowToast(
        "You cannot deselect all the Data Centers.",
        toastType.WARNING,
        5000,
        null
      );
      return false;
    }

    this.setState({ SelectedDC: SelectedDC }, () => {
      this.initDataAndChart(this.state.radioValue);
    });
  };

  /** handle change */
  handleRadioChange = e => {
    this.initDataAndChart(e);
  };

  /** key point change */
  handleKeyPointChange = e => {
    // console.log(e);
    this.setState({ selectedKeyPoint: e }, () => {
      this.initDataAndChart(this.state.radioValue);
    });
  };

  /** group by sort */
  _groupBy(myArray) {
    const groups = {};
    for (let i = 0; i < myArray.length; i++) {
      const groupName = myArray[i].attributeName;
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      const hasChild =
        myArray.find(
          x =>
            x.parentAccountCode == myArray[i].accountCode && x.accountCode != ""
        ) != undefined
          ? true
          : false;
      myArray[i].hasChild = hasChild;
      myArray[i].isOpen = false;
      groups[groupName].push(myArray[i]);
    }
    myArray = [];
    for (const groupName in groups) {
      myArray.push(groups[groupName]);
    }
    this.setState({ PropertyDetail: myArray });
  }

  /** Init data and charts */
  initDataAndChart = type => {
    const { selectedKeyPoint } = this.state;
    const currentYearValue = parseInt(
      moment(localStorage.getItem("selectedstartDate")).format("YYYY")
    );
    let currentQuarter;
    let startDate = localStorage.getItem("selectedstartDate");
    let endDate = localStorage.getItem("selectedstartDate");
    const properties = this.getSelectedProperties();
    let datePeriodType = type;
    if (type == "qtd") {
      startDate = moment(startDate)
        .quarter(moment(startDate).quarter())
        .startOf("quarter");
      endDate = moment(startDate)
        .quarter(moment(startDate).quarter())
        .endOf("quarter");
      currentQuarter = moment(startDate).quarter();
    } 

    if (type == "ytd") {
      datePeriodType = "mtd";
    }

    const params = {
      id: properties,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      datePeriodType: datePeriodType.toUpperCase()
    };

    const params1 = {
      id: properties,
      startDate: moment(startDate)
        .subtract(1, "years")
        .format("YYYY-MM-DD"),
      endDate: moment(endDate)
        .subtract(1, "years")
        .format("YYYY-MM-DD"),
      datePeriodType: datePeriodType.toUpperCase()
    };

    const params2 = {
      id: properties,
      startDate: moment(startDate)
        .subtract(2, "years")
        .format("YYYY-MM-DD"),
      endDate: moment(endDate)
        .subtract(2, "years")
        .format("YYYY-MM-DD"),
      datePeriodType: datePeriodType.toUpperCase()
    };

    apiBatchRequest([
      {
        url: API_URL.finance.GetPropertyFinanceDetails,
        params,
        key: "currentYear"
      },
      {
        url: API_URL.finance.GetPropertyFinanceDetails,
        params: params1,
        key: "lastYear"
      },
      {
        url: API_URL.finance.GetPropertyFinanceDetails,
        params: params2,
        key: "lastToLastYear"
      }
    ]).then(({ currentYear, lastYear, lastToLastYear }) => {
      //console.log(selectedKeyPoint);
      let {dataValuesBA} = this.state;
      dataValuesBA = [];
      if (type == "ytd") {
        // const budget = dataValuesBA.push({
        //   year: currentYearValue,
        //   Budgeted: checkNegative(
        //     (
        //       (((currentYear || {}).data || {}).data || []).filter(x => {
        //         return (
        //           (x.attributeType == "YTDBudget" &&
        //             x.attributeName == selectedKeyPoint) == true
        //         );
        //       }) || []
        //     ).reduce(function(prev, cur) {
        //       return prev + (parseFloat(cur.attributeValue || 0) || 0);
        //     }, 0),
        //     false
        //   ),
        //   Actual: checkNegative(
        //     (
        //       (((currentYear || {}).data || {}).data || []).filter(x => {
        //         return (
        //           (x.attributeType == "YTDActual" &&
        //             x.attributeName == selectedKeyPoint) == true
        //         );
        //       }) || []
        //     ).reduce(function(prev, cur) {
        //       return prev + (parseFloat(cur.attributeValue) || 0);
        //     }, 0),
        //     false
        //   )
        // });
        dataValuesBA.push({
          year: currentYearValue - 1,
          Budgeted: checkNegative(
            (
              (((lastYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "YTDBudget" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          ),
          Actual: checkNegative(
            (
              (((lastYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "YTDActual" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          )
        });
        dataValuesBA.push({
          year: currentYearValue - 2,
          Budgeted: checkNegative(
            (
              (((lastToLastYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "YTDBudget" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          ),
          Actual: checkNegative(
            (
              (((lastToLastYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "YTDActual" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          )
        });
      } else if (type == "mtd" || type == "qtd") {
        dataValuesBA.push({
          year: currentYearValue,
          quater: currentQuarter,
          Budgeted: checkNegative(
            (
              (((currentYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "MTDBudget" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          ),
          Actual: checkNegative(
            (
              (((currentYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "MTDActual" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          )
        });
        dataValuesBA.push({
          year: currentYearValue - 1,
          quater: currentQuarter,
          Budgeted: checkNegative(
            (
              (((lastYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "MTDBudget" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          ),
          Actual: checkNegative(
            (
              (((lastYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "MTDActual" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          )
        });
        dataValuesBA.push({
          year: currentYearValue - 2,
          quater: currentQuarter,
          Budgeted: checkNegative(
            (
              (((lastToLastYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "MTDBudget" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          ),
          Actual: checkNegative(
            (
              (((lastToLastYear || {}).data || {}).data || []).filter(x => {
                return (
                  (x.attributeType == "MTDActual" &&
                    x.attributeName == selectedKeyPoint) == true
                );
              }) || []
            ).reduce(function(prev, cur) {
              return prev + (parseFloat(cur.attributeValue) || 0);
            }, 0),
            false
          )
        });
      }
      const chartData = this.generateChartData(
        ((currentYear || {}).data || {}).data || []
      );
      this.setState({
        dataValuesBA: dataValuesBA,
        radioValue: type,
        ytdGraphData: chartData.ytdGraphData,
        mtdGraphData: chartData.mtdGraphData
      });
    });
  };

  /** selected properties */
  getSelectedProperties = () => {
    const selectedProperties = [];
    const { SelectedDC } = this.state;
    SelectedDC.map(dataCenter => {
      selectedProperties.push(this.getDwId(dataCenter));
    });
    return removeDuplicates(selectedProperties).toString();
  };

  /** Chart data */
  generateChartData = data => {
    const { SelectedDC } = this.state;
    let MTDBudget;
    let MTDActual;
    let YTDBudget;
    let YTDActual;
    const CreatedYtdData = [];
    const CreatedMtdData = [];
    SelectedDC.map(dataCenter => {
      (
        (data || []).filter(x => x.propertyKey == this.getDwId(dataCenter)) ||
        []
      ).map((item) => {
        if (
          item.attributeName == this.state.selectedKeyPoint &&
          item.attributeType == "MTDBudget"
        ) {
          MTDBudget = Math.round(parseFloat(item.attributeValue) || 0);
        }
        if (
          item.attributeName == this.state.selectedKeyPoint &&
          item.attributeType == "MTDActual"
        ) {
          MTDActual = Math.round(parseFloat(item.attributeValue) || 0);
        }

        if (
          item.attributeName == this.state.selectedKeyPoint &&
          item.attributeType == "YTDBudget"
        ) {
          YTDBudget = Math.round(parseFloat(item.attributeValue) || 0);
        }
        if (
          item.attributeName == this.state.selectedKeyPoint &&
          item.attributeType == "YTDActual"
        ) {
          YTDActual = Math.round(parseFloat(item.attributeValue) || 0);
        }
      });
      const dataCenterAbbr = this.props.datacenterList.filter(
        x => x.name == dataCenter
      );
      CreatedYtdData.push({
        dataCenter: dataCenterAbbr[0].abbreviation,
        Budgeted: YTDBudget,
        Actual: YTDActual
      });
      CreatedMtdData.push({
        dataCenter: dataCenterAbbr[0].abbreviation,
        Budgeted: MTDBudget,
        Actual: MTDActual
      });
    });
    resDataGraphMtd = getChartData([...CreatedMtdData] || [], configDataMtd);
    resDataGraphYtd = getChartData([...CreatedYtdData] || [], configDataYtd);
    return {
      mtdGraphData: CreatedMtdData,
      ytdGraphData: CreatedYtdData
    };
  };

  /** DW Id */
  getDwId = DcName => {
    const data = this.state.datacenterList;
    let a;
    data.map(item => {
      if (item.name == DcName) {
        a = item.dwPropertyId;
      }
    });
    return a;
  };

  render() {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 400
        }
      }
    };

    const { selectedKeyPoint } = this.state;
    return (
      <Grid container className={"point-compare-finance"}>
        <Grid item xs={12}>
          <Box>
            <Grid container>
              <Grid item xs={12}>
                <RadioGroup
                  aria-label={""}
                  value={this.state.radioValue}
                  name={"Year to date"}
                  onChange={() => this.handleRadioChange(event.target.value)}
                  row
                  style={{ paddingLeft: "10px" }}
                >
                  <FormControlLabel
                    control={<Radio />}
                    label={"MTD"}
                    value={"mtd"}
                    size={"small"}
                  />
                  <FormControlLabel
                    control={<Radio />}
                    label={"YTD"}
                    value={"ytd"}
                    size={"small"}
                  />

                  <FormControlLabel
                    control={<Radio />}
                    label={"QTD"}
                    value={"qtd"}
                    size={"small"}
                  />
                </RadioGroup>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Grid container className={"key-box"}>
            <Grid item xs={3}>
              <Box mt={2} pl={1}>
                <FormControl>
                  <InputLabel id={"demo-simple-select-label"}>
                    {"Key Point\r"}
                  </InputLabel>
                  <Select
                    labelId={"demo-simple-select-label"}
                    className={"key-point-select"}
                    id={"demo-simple-select"}
                    value={this.state.selectedKeyPoint}
                    size={"small"}
                    onChange={e => this.handleKeyPointChange(e.target.value)}
                    style={{ width: "100%" }}
                  >
                    {(this.state.PropertyDetail || []).map(item =>
                      item[0].parentAccountCode == "" || item[0].hasChild ? (
                        <MenuItem value={item[0].attributeName}>
                          {item[0].attributeName}
                        </MenuItem>
                      ) : null
                    )}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={9}>
              <Box mt={2}>
                <FormControl>
                  <InputLabel id={"demo-multiple-chip-label"}>{"With"}</InputLabel>
                  <Select
                    labelId={"demo-multiple-chip-label"}
                    id={"demo-multiple-chip"}
                    multiple
                    value={this.state.SelectedDC}
                    onChange={e => this.handleChange(e.target.value, "value")}
                    input={<Input id={"select-multiple-chip"} />}
                    renderValue={selected => (
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {selected.map((value, index) => (
                          <Chip
                            key={value + index}
                            label={value}
                            style={{ margin: "2px" }}
                            onDelete={() => this.handleChange(value, "chip")}
                            onMouseDown={event => {
                              event.stopPropagation();
                            }}
                          />
                        ))}
                      </div>
                    )}
                    MenuProps={MenuProps}
                  >
                    {(this.state.datacenterList || []).map(item =>
                      item.dwPropertyId != 0 ? (
                        <MenuItem key={item.propertyID} value={item.name}>
                          {item.name}
                        </MenuItem>
                      ) : null
                    )}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Box mt={2}>
            <Grid container>
              <Grid item xs={5}>
                <Box>
                  <div className={"graph-box"} id={"MonthToDate_container"}>
                    <b>
                      {selectedKeyPoint || ""}{" "}
                      {this.state.radioValue == "qtd" ? "Quater " : "Month "}{"To\r"}
                      {"Date\r"}
                    </b>
                    {resDataGraphMtd !== undefined ? (
                      <div id={"MonthToDate"} style={{ height: "100%" }}>
                        <RenderChart
                          identifier={"MonthToDate"}
                          allowDrillDown={false}
                          chartConfig={{
                            data: this.state.mtdGraphData,
                            type: "GroupBarChart",
                            keys: resDataGraphMtd.barKeys,
                            colors: resDataGraphMtd.barColors,
                            accessor: "dataCenter",
                            configuration: configDataMtd,
                            rawData: this.state.mtdGraphData,
                            yAxisLabel: "  ",
                            xAxisLabel: selectedKeyPoint
                          }}
                          legends={resDataGraphMtd.legends}
                        />
                      </div>
                    ) : null}
                  </div>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box ml={1} mr={1}>
                  {this.state.dataValuesBA &&
                    this.state.dataValuesBA.map(item => (
                      <div className={"info-box"}>
                        <div className={"year-title"}>
                          {item.quater != undefined
                            ? "Q" + item.quater + " "
                            : ""}{" "}
                          {"FY- "}{item.year}
                          <Typography
                            variant={"caption"}
                            display={"block"}
                            gutterBottom
                          >
                            {"("}{this.state.radioValue.toUpperCase()}{")\r"}
                          </Typography>{" "}
                        </div>
                        <div className={"year-title-title-row year-title-digit d-flex"}>
                          <div className={"w-50"}>{"Budgeted ($)"}</div>
                          <div className={"w-50"}>{"Actual ($)"}</div>
                        </div>
                        <hr />
                        <div className={"year-title-title-row  d-flex"}>
                          <div className={"w-50"} style={{ fontSize: "13px" }}>
                            {item.Budgeted.toLocaleString()}
                          </div>
                          <div className={"w-50"} style={{ fontSize: "13px" }}>
                            {item.Actual.toLocaleString()}
                          </div>
                        </div>
                      </div>
                    ))}
                </Box>
              </Grid>
              <Grid item xs={5}>
                <Box>
                  <div className={"graph-box"} id={"YearToDate_container"}>
                    <b>{selectedKeyPoint || ""}{"&nbsp;Year To Date"}</b>

                    {resDataGraphYtd !== undefined ? (
                      <div id={"YearToDate"} style={{ height: "100%" }}>
                        <RenderChart
                          identifier={"YearToDate"}
                          allowDrillDown={"false"}
                          chartConfig={{
                            data: this.state.ytdGraphData,
                            type: "GroupBarChart",
                            keys: resDataGraphYtd.barKeys,
                            colors: resDataGraphYtd.barColors,
                            accessor: "dataCenter",
                            configuration: configDataYtd,
                            rawData: this.state.ytdGraphData,
                            yAxisLabel: "  ",
                            xAxisLabel: selectedKeyPoint,
                            tooltip: "Amount"
                          }}
                          legends={resDataGraphYtd.legends}
                        />
                      </div>
                    ) : null}
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    );
  }
}

export default PointCompare;
